import { h } from 'preact';
import Form from 'components/bolt/forms/form/form';

export default class EmailForm extends Form {
	constructor(props) {
		super(props);
		this.shouldRenderCaptcha = true;
	}
	onFormSubmit(e) {
		if (!this.props.htmlSubmit) {
			e.preventDefault();
			return;
		}
		// Assume the form was correctly submitted
		this.props.setFormSubmitted?.();
	}

}
